import { render, staticRenderFns } from "./StumpageSection.vue?vue&type=template&id=614be544"
import script from "./StumpageSection.vue?vue&type=script&lang=js"
export * from "./StumpageSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports